<template>
<div>
    <b-row>
        <modal_postcode ref="modal_postcode" @confirm="selectAddress" />
        <modal_image ref="modal_image" :data="this.form.registrationNumberUrl" />

        <b-colxx xxs="12">

            <b-card xxs="8" class="mb-4 weight600" title="매장 기본 정보">
                <b-form-group label-cols="2" horizontal :label="$t('store.name')">
                    <b-input-group size="md" class="col-9 pl-0">
                        <b-form-input v-model="form.storeName"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="outline-secondary" :disabled="overlapCheck" @click="duplicationCheck">
                                {{ $t('button.overlap-check') }}
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
                <b-form-group label-cols="2" horizontal :label="$t('store.type')">
                    <!-- <b-input-group prepend="선택"> -->
                    <v-select size="sm" :options="storeTypeOptions" placeholder="업종선택하세요" v-model="form.storeType" style="width:26.5%;"></v-select>
                    <!-- </b-input-group> -->
                </b-form-group>

                <b-form-group label-cols="2" horizontal :label="$t('store.registrationNumber')">
                    <b-input-group size="" class="col-9 pl-0 fileInputSize">
                        <b-form-input v-model="form.registrationNumber" placeholder="사업자등록번호" class="mr-3"></b-form-input>

                        <b-form-file accept="image/*" :browse-text="browseText" v-model="form.registrationNumberFile" :placeholder="placeholderImg"></b-form-file>

                        <b-input-group-append v-if=" form.registrationNumberFile != null">
                            <b-button class="fileCustomBtn" variant="outline-secondary" @click="getBusinessLicenseImage" >미리보기</b-button>
                        </b-input-group-append>

                    </b-input-group>

                    <b-form-row>
                    </b-form-row>
                </b-form-group>

                <b-form-group label-cols="2" horizontal :label="$t('store.address')">
                    <b-input-group class="col-9 pl-0">
                        <b-form-input placeholder="" type="text" v-model="form.address3" disabled></b-form-input>
                        <b-form-input placeholder="" type="text" v-model="form.detailAddress"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="outline-secondary" @click="searchAddress">{{ $t('button.search-address') }}</b-button>
                        </b-input-group-append>

                    </b-input-group>
                </b-form-group>

                <b-form-group label-cols="2" horizontal label="대표전화">
                    <b-input-group size="" class="col-5 pl-0">
                        <b-form-input v-model="form.phone" placeholder="하이픈(-)을 포함해서 입력해주세요"></b-form-input>
                    </b-input-group>
                </b-form-group>

                <b-form-group label-cols="2" horizontal label="좌석수">
                    <b-input-group size="" class="col-2 pl-0">
                        <!-- <b-form-input type="text" v-model="form.seat" min="0" @input="numberCheck($event,'ss')"></b-form-input><span class="seatSpan">석</span> -->
                        <input class="form-control" type="text" v-model="form.seat" min="0" @input="numberCheck($event)"><span class="seatSpan">석</span>
                    </b-input-group>
                </b-form-group>

                <b-form-group label-cols="2" horizontal label="개업일">
                    <b-input-group size="" class="col-2 pl-0">
                        <!-- {{ form.openDate }} -->
                        <vue-monthly-picker v-model="form.openDate" :clearOption="false" dateFormat="YYYY-MM" :monthLabels="['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']" selectedBackgroundColor="#c11314" alignment="center" :max="this.$moment(new Date().setMonth(new Date().getMonth()-1))">
                        </vue-monthly-picker>
                    </b-input-group>
                </b-form-group>

                <b-form-group label-cols="2" horizontal :label="'지역 카테고리'">
                    <b-form-select style="width: 20%" class="" v-model="mainAreaNum" :options="zone1Options" @change="mainAreaChange()">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>도/시</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-select style="width: 20%" class="" v-model="middleAreaNum" :options="zone2Options" @change="middleAreaChange($event,true)">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>구</b-form-select-option>
                        </template>
                    </b-form-select>
                    <b-form-select style="width: 20%" class="" v-model="smallAreaNum" :options="zone3Options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled>동</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
                <template v-if="kakaoId">
                  <hr>
                  <div class="box-header mt-4 mb-4">
                    <h3 class="box-title">카카오톡 예약하기 장소 기본정보</h3>
                  </div>
                  <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="예약 카테고리">
                    <div class="input-group d-flex mb-3" v-for="idx in categoryLength+1" style=" width: 70%">
                      <select class="form-control mr-3 col-4" v-model="dep1Selected[idx-1]"
                              @change="dep1Change(dep1Selected[idx-1],idx-1 )">
                        <option v-for="(dp1Cate, dp1Idx) in kakaoCategoryList" :value="dp1Cate">
                          {{ dp1Cate.categoryName }}
                        </option>
                      </select>
                      <select class="form-control mr-3 col-4" v-model="selectedCategoryList[idx-1]">
                        <option v-for="(dp2Cate, dp2Idx) in dep2ArrList[idx-1]" :value="dp2Cate.categoryCode">
                          {{ dp2Cate.categoryName }}
                        </option>
                      </select>
                      <button class="btn btn-outline-success" style="padding-top: 0px; padding-bottom: 0px;"
                              v-if="categoryLength == 1" @click="removeReserveCategory(idx-1)"> 삭제
                      </button>
                      <button class="btn btn-outline-success" style="padding-top: 0px; padding-bottom: 0px;"
                              v-if="categoryLength == 0" @click="addReserveCategory">추가
                      </button>
                    </div>
                  </b-form-group>
                  <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="장소명">
                    <b-form-input placeholder="" type="text" v-model="placeName" ></b-form-input>
                  </b-form-group>
                  <b-form-group label-cols="2" horizontal class="weight600 " id="storeStatus" label="카카오맵 장소 아이디">

                    <b-form-input class="col-5" size="sm" placeholder="" type="text" v-model="placeId" ></b-form-input>

                    <div class="align-content-center mt-2" >1. Kakao Map 접속 (<a href="https://map.kakao.com" target="_blank"
                                                                                style="color: #007bff">https://map.kakao.com</a>)<br>
                      2. 매장 장소 검색<br>
                      3. 좌측 검색결과에서 해당 장소에 “상세보기” 클릭<br>
                      4. 연결된 URL에 기재된 장소아이디 확인하여 입력 (https://place.map.kakao.com/{장소아이디})<br>
                      ex) https://place.map.kakao.com/14559670 > 카카오맵 장소 아이디에 “14559670” 입력<br>
                    </div>
                  </b-form-group>
                </template>
                <div class="text-center">
                    <b-button variant="primary" class="mt-4 ml-2" @click.prevent="onSave">저장</b-button>
                </div>
            </b-card>
        </b-colxx>
    </b-row>
    <b-button variant="outline-primary" class="mt-0" @click.prevent="onCancel">뒤로</b-button>
</div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {
    mapGetters,
    mapActions
} from "vuex";
import ModalPostcode from "../components/ModalPostcode";
import ModalImage from '../components/ModalImage'
import {
    storeTypeList
} from '../../../utils'

import api from "../../../constants/api";

const {
    BlobServiceClient,
    ContainerClient
} = require('@azure/storage-blob');

export default {
    components: {
        'v-select': vSelect,
        'modal_postcode': ModalPostcode,
        'modal_image': ModalImage

    },
    data() {
        return {
            userRole: null,
            browseText: '수정',
            mainAreaNum: null,
            middleAreaNum: null,
            smallAreaNum: null,

            storeArea: [],
            address: {},
            placeholderImg: '파일을 선택하세요...',
            form: {
                openDate: this.$moment(new Date().setMonth(new Date().getMonth() - 1)),
                zone1: '',
                zone2: '',
                zone3: '',
                seat: '',
                storeCode: this.$route.params.storeCode,
                originalStoreName: '',
                storeName: '',
                address1: '',
                address2: '',
                address3: '',
                detailAddress: '',
                zipCode: '',
                storeType: '',
                registrationNumber: '',
                registrationNumberFile: null,
                registrationNumberUrl: '',
                // homepage: '',
                phone: '',
                representative: '',
                region: '',
                city: '',
            },
            overlapCheck: true,
            storeTypeOptions: [],
            zone1Options: [],
            zone2Options: [],
            zone3Options: [],
            flag: true,
            kakaoId:null,
            addCategory : false,
            categoryLength: 0,
            kakaoCategoryList:[],
            dep1Selected:[
            ],
            dep2ArrList:[
              [{categoryCode:"2차 선택",
                categoryName:"2차 선택",
                categoryNum:0
              }]
            ],
            selectedCategoryList: [],
            placeName:"",
            categoryList:[],
            placeId:"",
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    created() {
        this.getstoreAreas();
        this.getStoreType();
    },
    mounted() {
        this.userRole = this.currentUser.userRole.split('_')[0]
    },
    methods: {
        getStoreType() {
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeType)
            this.$http.get(reqURL, {
                params: '',
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                this.storeTypeOptions = [];
                res.data.data.types.forEach(el => {
                    this.storeTypeOptions.push({
                        label: el.typeName,
                        value: el.storeType,
                    })
                });
            }).catch(err => {

            })
        },
        numberCheck(eve) {
            const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/;

            // 한글, 영문 체크
            if (reg.exec(eve.path[0].value) !== null) {
                eve.path[0].value = eve.path[0].value.replace(/[^0-9]/g, '');
                this.form.seat.replace(/[^0-9]/g, '');
            };
            if (isNaN(parseFloat(eve.path[0].value))) {
                eve.path[0].value = ''
                this.form.seat = ''
            };
        },
        mainAreaChange() {
            this.middleAreaNum = null;
            this.smallAreaNum = null;
        },
        async loadData() {

            let reqURL = ''
            if (this.userRole == "BRAND") {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.basicInfo)
            } else {
                reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.basicInfoStr)
            }

            const params = {
                storeCode: this.form.storeCode
            }

            // console.log(reqURL)
            // console.log(params)

            let res = await this.$http.get(reqURL, {
                params: params,
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            });
            try {
                if (res.data.code === "OK") {

                    const data = res.data.data

                    this.form.storeName = data.basicInfo.storeName
                    this.form.originalStoreName = data.basicInfo.storeName //이름 중복체크

                    this.form.storeType = this.storeTypeOptions.find(x => x.value === data.basicInfo.storeType)
                    this.form.registrationNumber = data.basicInfo.registrationNumber
                    this.form.registrationNumberUrl = data.basicInfo.registrationNumberUrl
                    this.placeholderImg = data.basicInfo.registrationNumberUrl.substr(0, 30)
                    this.form.registrationNumberFile = {
                        "name": "TestName.jpg",
                        "url": data.basicInfo.registrationNumberUrl,

                    }
                    this.form.phone = data.basicInfo.phoneNumber
                    // this.form.homepage = data.basicInfo.homePageUrl

                    this.form.address3 = data.address.roadAddress;
                    this.form.detailAddress = data.address.detailAddress;

                    this.form.seat = data.basicInfo.seat;
                    this.form.openDate = data.basicInfo.openDate;

                    this.address.roadAddress = data.address.roadAddress
                    this.address.jibunAddress = data.address.jibunAddress
                    this.address.engAddress = data.address.engAddress
                    this.address.zipCode = data.address.zipCode
                    this.address.latitude = data.address.coordinateY
                    this.address.longitude = data.address.coordinateX
                    this.address.coordinateSystem = data.address.coordinateSystem
                    this.address.region= data.address.region
                    this.address.city= data.address.city

                    this.mainAreaNum = data.address.mainAreaNum
                    this.middleAreaNum = data.address.middleAreaNum;
                    this.smallAreaNum = data.address.smallAreaNum;
                    this.kakaoId = data.kakaoId
                    if(data.kakaoInfo.placeId !=null){
                      this.placeName = data.kakaoInfo.placeName
                      this.placeId =  data.kakaoInfo.placeId
                      this.categoryList = data.kakaoInfo.categoryList


                    }

                      this.getKakaoCategoryList();
                    // console.log(this.smallAreaNum)

                } else {
                    throw 400
                }
            } catch (err) {
                // throw 400
                alert(err)
            }

        },

        getBusinessLicenseImage: function () {
            this.popupImage()
        },

        popupImage() {
            // this.$refs.modal_image.open()
            window.open(this.form.registrationNumberUrl, "", "width=600,height=400,left=200,top=200");
        },

        //지역카테고리 데이터
        async getstoreAreas() {

            const vm = this

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.area)
            try {
                let res = await this.$http.get(reqURL, {});
                console.log("DURL")
                console.log(res);
                if (res.data.code === "OK") {
                    this.storeArea = res.data.data.mainAreas
                    console.log(this.storeArea)
                    this.storeArea.forEach(function (option, index) {
                        vm.zone1Options.push({
                            text: option.areaName,
                            value: option.areaNum
                        })
                    })
                }

            } catch (err) {
                alert(err);
            }
            this.loadData();
        },

        async getKakaoCategoryList() {
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.getKakaoCategoryList)
            try {
                let res = await this.$http.get(reqURL, {headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}});

                if(res.data.code === "OK") {
                    this.kakaoCategoryList = res.data.data.mainCategoryList
                    this.kakaoCategoryList.unshift({
                      categoryName: "1차 선택",
                      categoryNum: 0,
                      subCategoryList:[{categoryCode:"2차 선택",
                        categoryName:"2차 선택",
                        categoryNum:0
                      }]
                    })
                    this.dep1Selected[0] = {
                      categoryName: "1차 선택",
                      categoryNum: 0,
                      subCategoryList:[{categoryCode:"2차 선택",
                        categoryName:"2차 선택",
                        categoryNum:0
                      }]

                    }
                    console.log(this.categoryList.length);

                    for (let i =0 ; i <this.categoryList.length; i++){
                        let tmp = this.categoryList[i];
                        for(let j =0 ; j<this.kakaoCategoryList.length;j++){
                          for(let k =0 ; k<this.kakaoCategoryList[j].subCategoryList.length ; k++){
                            if (this.kakaoCategoryList[j].subCategoryList[k].categoryCode == tmp){
                              this.dep2ArrList.splice(i,0,this.kakaoCategoryList[j].subCategoryList)
                              this.dep1Selected.splice(i,0,this.kakaoCategoryList[j])
                              this.selectedCategoryList.splice(i,0,this.kakaoCategoryList[j].subCategoryList[k].categoryCode)

                            }
                          }
                        }
                      }
                      if(this.selectedCategoryList.length > 1) {
                          this.categoryLength = 1
                      }
                } else {
                    throw 400
                }
            } catch (err) {
                alert(err);
            }
        },

        //매장명 중복검사
        duplicationCheck() {
            if (this.form.storeName.length < 2) {
                alert('매장명을 2자 이상 입력하세요.')
                return false
            }

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.exists)
            const params = {
                brandCode: this.siteName,
                storeName: this.form.storeName
            }

            this.$http.get(reqURL, {
                params: params,
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                this.overlapCheck = !res.data.data
                if (res.data.data === false) {
                    alert('사용 가능합니다.')
                } else {
                    alert('중복된 매장명입니다.')
                    this.form.storeName = '' //초기화
                }
            }).catch(err => {
                alert(err.response.data.message);
                this.overlapCheck = false
            })
        },

        searchAddress() {
            this.$refs.modal_postcode.open()
        },

        selectAddress(data) {
            console.log(data.data)
            this.form.detailAddress = data.data.detailAddress
            this.form.address3 = data.data.roadAddress
            this.address = data.data
        },

        onCancel() {
            this.$router.back();
        },

        onSave() {
            // console.log(this.smallAreaNum)
          let chkCati = this.selectedCategoryList.indexOf("2차 선택")
            if (this.form.storeName === "") {
                alert('매장명을 입력해주세요')
                return false
            } else if (!this.overlapCheck) {
                alert('매장명을 중복확인 해주세요.')
                return false
            } else if (this.form.address3 === "") {
                alert('주소검색을 통해 주소를 입력해주세요')
                return false
            } else if (this.form.storeType === "") {
                alert('업종을 선택해주세요.')
                return false
            } else if (this.form.registrationNumber === "") {
                alert('사업자 등록번호를 입력해 주세요.')
                return false
            } else if (this.form.seat === '' || this.form.seat === undefined) {
                alert('좌석수를 입력해 주세요.');
                return false
            } else if (this.form.zone1 === "" || this.form.zone2 === "" || this.form.zone3 === "") {
                alert('지역 카테고리를 입력해 주세요.')
                return false
            }else if(this.kakaoId && !this.placeName ){
              alert("장소명을 입력해주세요.")
              return false
            } else if(this.kakaoId && chkCati > -1 ){
              alert("예약 카테고리를 선택해주세요.")
              return false
            } else if(this.kakaoId && !this.placeId ){
              alert("카카오맵 장소 아이디를 입력해주세요.")
              return false
            } else {
                console.log(this.address.roadAddress)
                const address = {
                    roadAddress: this.address.roadAddress,
                    jibunAddress: this.address.jibunAddress,
                    detailAddress: this.form.detailAddress,
                    engAddress: this.address.engAddress,
                    zipCode: this.address.zipCode,
                    coordinateX: Number(this.address.longitude),
                    coordinateY: Number(this.address.latitude),
                    mainAreaNum: this.mainAreaNum,
                    middleAreaNum: this.middleAreaNum,
                    smallAreaNum: this.smallAreaNum,
                    coordinateSystem: this.address.coordinateSystem == undefined ? 'EPSG4326' : this.address.coordinateSystem,
                    region: this.address.region,
                    city: this.address.city
                }

                const kakaoInfo = {
                  placeId: this.placeId,
                  placeName: this.placeName,
                  categoryList : this.selectedCategoryList
                }

                // console.log(this.form.openDate);
                const params = {
                    storeCode: this.form.storeCode,
                    address: address,
                    basicInfo: {
                        storeName: this.form.storeName,
                        storeType: this.form.storeType.value,
                        phoneNumber: this.form.phone,
                        // homePageUrl: this.form.homepage,
                        registrationNumber: this.form.registrationNumber,
                        registrationNumberUrl: this.form.registrationNumberUrl,
                        seat: this.form.seat,
                        openDate: this.$moment(this.form.openDate).format("YYYY-MM"),
                    },
                    kakaoInfo: kakaoInfo,

                }

                let reqURL = ''
                if (this.userRole == "BRAND") {
                    reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.basicInfoUpdate)
                } else {
                    reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.basicInfoUpdateStr)
                }

                this.$http.post(reqURL, params, {
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                  this.$emit('get-kakao-alert', 'STORE');
                    alert('변경하였습니다.')
                    this.$router.go(0)
                }).catch(err => {
                    alert(err.response.data.message);
                })
            }
        },

        AzureFileUpload() {
            const vm = this;
            return new Promise(function (resolve, reject) {

                let reqURL = api.changeAPI(vm.siteName, api.basicURL + api.user.azureSas);
                let params = {
                    type: "STORE"
                }

                vm.$http.post(reqURL, params, {
                    headers: {
                        'Authorization': `Bearer ${vm.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    // if(res.data.code === "OK") {
                    let containerUrl = res.data.data.url
                    const containerClient = new ContainerClient(containerUrl);

                    const file = vm.form.registrationNumberFile;

                    const blockBlobClient = containerClient.getBlockBlobClient(`${res.data.data.directory}/${file.name}`);

                    blockBlobClient.uploadBrowserData(file, {
                        blockSize: 4 * 1024 * 1024, // 4MB block size
                        blobHTTPHeaders: {
                            blobContentType: file.type
                        }
                    }).then(success => {
                        // console.log("success", success)
                        let uploadedUrl = success._response.request.url.substring(0, success._response.request.url.indexOf("?sig="))
                        vm.form.registrationNumberUrl = uploadedUrl
                        // console.log(vm.form.registrationNumberUrl);

                    }).catch(reason => {
                        alert("업로드 실패")
                    })

                    resolve('sss');

                    // } else {
                    //   throw 400
                    // }
                }).catch(err => {
                    reject(new Error('업로드 실패'));
                });
            })

        },
        middleAreaChange(val, selType) {
            const vm = this
            console.log(val);
            if (selType) {
                this.smallAreaNum = null;
            }
            if (vm.storeArea.length !== 0) {
                vm.storeArea.forEach(function (option, i) {
                    option.middleAreas.forEach(function (moption, j) {
                        if (val === moption.areaNum) {
                            vm.zone3Options = [];
                            moption.smallAreas.forEach(function (soption, s) {
                                vm.zone3Options.push({
                                    text: soption.areaName,
                                    value: soption.areaNum
                                })
                            })
                        }
                    })
                })
            }

        },
      addReserveCategory(){
        this.addCategory = true
        this.categoryLength = 1;
        this.dep1Selected[1] = {
          categoryName: "1차 선택",
          categoryNum: 0,
          subCategoryList:[ {categoryCode:"2차 선택",
            categoryName:"2차 선택",
            categoryNum:0
          }]
        }
        this.dep2ArrList.push(
          [{categoryCode:"2차 선택",
            categoryName:"2차 선택",
            categoryNum:0
          }])
        this.selectedCategoryList.push("2차 선택")
      },
      removeReserveCategory(val){
        this.selectedCategoryList.splice(val,1)
        this.dep1Selected.splice(val,1)
        this.dep2ArrList.splice(val,1)
        this.categoryLength = 0
        this.addCategory = false
      },
      dep1Change(val,idx){
        this.dep2ArrList[idx] = val.subCategoryList
      }

    },

    watch: {

        'form.storeName': function (newValue) {
            if (this.form.storeName !== this.form.originalStoreName) {
                this.overlapCheck = false;
            } else {
                this.overlapCheck = true;
            }
        },

        'form.registrationNumberFile': function (val) {
            if (val.type != undefined) {
                const azureInfo = this.AzureFileUpload();
                console.log(azureInfo)
            }
        },

        'form.zone1': function (val) {
            const vm = this
            if (this.storeArea.length !== 0) {
                this.storeArea.forEach(function (option, i) {
                    if (vm.form.zone1 == option.areaNum) {
                        vm.zone2Options = []
                        vm.zone3Options = []
                        if (vm.flag) {
                            vm.flag = false
                        } else {
                            vm.form.zone = ''
                        }
                        option.middleAreas.forEach(function (moption, j) {
                            vm.zone2Options.push({
                                text: moption.areaName,
                                value: moption.areaNum
                            })
                        })
                    }
                })
            }

        },
        mainAreaNum() {
            this.form.zone1 = this.mainAreaNum
        },
        middleAreaNum() {
            this.form.zone2 = this.middleAreaNum
            this.middleAreaChange(this.middleAreaNum, false);
        },
        smallAreaNum() {
            this.form.zone3 = this.smallAreaNum
        },


    }

}
</script>
